/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Camera_CollapseInputs */

const vi_fleet_camera_collapse = /** @type {(inputs: Fleet_Camera_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu nhỏ`)
};

/**

* @param {Fleet_Camera_CollapseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_camera_collapse = /** @type {((inputs?: Fleet_Camera_CollapseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Camera_CollapseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_camera_collapse(inputs)
});